import { CommonModule } from '@angular/common';
import { Component, afterRender, input, signal } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SwipeDirective } from './swipe.directive';

@Component({
  selector: 'bo-carousel',
  templateUrl: './carousel.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule, SwipeDirective],
})
export class CarouselComponent {
  images = input<string[] | SafeResourceUrl[]>([]);
  wasFullScreen = false;

  constructor() {
    afterRender(() => {
      if (!this.isFullscreen() && this.wasFullScreen) {
        this.scrollTo(this.index, true);
        this.wasFullScreen = false;
      }
      if (this.isFullscreen() && !this.wasFullScreen) {
        this.scrollTo(this.index, true);
        this.wasFullScreen = true;
      }
    });
  }

  index = 0;
  isFullscreen = signal(false);

  changeIndex(change: number) {
    let newIndex = this.index + change;
    newIndex =
      newIndex > this.images().length - 1 || newIndex < 0
        ? this.index
        : newIndex;
    this.scrollTo(newIndex);
  }

  scrollTo(index: number, fast?: boolean) {
    const element = document.getElementById('image' + index);
    element.scrollIntoView({
      behavior: fast ? 'instant' : 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
    this.index = index;
  }

  onSwipeLeft() {
    if (this.index < this.images().length - 1) {
      this.index++;
      this.scrollTo(this.index);
    }
  }

  onSwipeRight() {
    if (this.index > 0) {
      this.index--;
      this.scrollTo(this.index);
    }
  }
}
